"use strict";
// Coda CLI 聊天与 Agent 交互模块
Object.defineProperty(exports, "__esModule", { value: true });
const cli_core_1 = require("@/cli-core");
const chat_utils_1 = require("./chat-utils");
const types_1 = require("@/types");
const ai_util_1 = require("@/service/ai-util");
cli_core_1.Base.extends({
    /**
     * 初始化运行状态
     */
    async init() {
        const serverName = types_1.ServerNames.agnet;
        const serverPort = '10086';
        const savedConfig = ai_util_1.AIUtil.loadSavedAISetting();
        cli_core_1.Base.state = {
            serverName,
            serverPort,
            agentServerUrl: `http://127.0.0.1:${serverPort}`,
            protocol: 'ollama',
            baseUrl: savedConfig?.baseUrl || '',
            apiKey: savedConfig?.apiKey || '',
            model: savedConfig?.model || 'qwen3-coder:30b',
            options: savedConfig?.options || {
                contextSize: 32768,
            },
            modelList: [],
            enableMultiModel: false,
            taskMode: 'coding',
            success: false,
            savedConfig,
        };
        cli_core_1.Wait.next();
    },
    /**
     * 交互式引导与配置确认
     */
    async prompt() {
        /**
         * ollama不在线则直接退出
         */
        if (cli_core_1.Base.state.baseUrl && cli_core_1.Base.state.baseUrl.length !== 0) {
            const isOnline = await ai_util_1.AIUtil.verifyOllamaServiceConnection(cli_core_1.Base.state.baseUrl);
            if (!isOnline) {
                cli_core_1.CLI.loading.fail('检测到Ollama未服务运行，请先启动ollama服务...');
                process.exit(0);
            }
        }
        try {
            // 1. 检查已有配置并复用（内部已包含连通性校验）
            const reuseResult = await (0, chat_utils_1.handleConfigReuse)(cli_core_1.Base.state.savedConfig);
            if (reuseResult.reused) {
                cli_core_1.Base.state.baseUrl = reuseResult.baseUrl;
                cli_core_1.Base.state.apiKey = reuseResult.apiKey;
                cli_core_1.Base.state.model = reuseResult.model;
                cli_core_1.Base.state.agentServerUrl = reuseResult.agentServerUrl;
                cli_core_1.Base.state.options = reuseResult.options;
                cli_core_1.Base.state.enableMultiModel = reuseResult.enableMultiModel;
                if (reuseResult.enableMultiModel) {
                    cli_core_1.Base.state.options.architectureModel = reuseResult.architectureModel;
                }
            }
            else {
                // 2. 选择协议并配置网关
                const connection = await (0, chat_utils_1.setupConnection)(cli_core_1.Base.state.savedConfig);
                cli_core_1.Base.state.baseUrl = connection.baseUrl;
                cli_core_1.Base.state.apiKey = connection.apiKey;
                // 3. 拉取模型列表并选择模型
                const modelSelection = await (0, chat_utils_1.fetchAndSelectModels)(cli_core_1.Base.state.baseUrl, cli_core_1.Base.state.apiKey);
                cli_core_1.Base.state.modelList = modelSelection.modelList;
                cli_core_1.Base.state.enableMultiModel = modelSelection.enableMultiModel;
                cli_core_1.Base.state.model = modelSelection.model;
                cli_core_1.Base.state.taskMode = modelSelection.taskMode;
                if (modelSelection.enableMultiModel) {
                    cli_core_1.Base.state.options.architectureModel = modelSelection.architectureModel;
                }
                else {
                    cli_core_1.Base.state.options.architectureModel = undefined;
                }
                // 5. 选择上下文大小并持久化
                const currentSettings = {
                    protocol: cli_core_1.Base.state.protocol,
                    baseUrl: cli_core_1.Base.state.baseUrl,
                    apiKey: cli_core_1.Base.state.apiKey,
                    model: cli_core_1.Base.state.model,
                    agentServerUrl: cli_core_1.Base.state.agentServerUrl,
                    options: cli_core_1.Base.state.options,
                };
                const contextSize = await (0, chat_utils_1.saveAndPrintConfig)(currentSettings);
                cli_core_1.Base.state.options.contextSize = contextSize;
            }
        }
        catch (error) {
            cli_core_1.Base.state.success = false;
            cli_core_1.CLI.loading.fail(`交互中断: ${error.message}`);
            return;
        }
        cli_core_1.Wait.next();
    },
    /**
     * 核心对话循环
     */
    async default() {
        try {
            // 若配置阶段因服务未启动而中断，则跳过对话循环
            if (!cli_core_1.Base.state.baseUrl) {
                cli_core_1.Wait.next();
                return;
            }
            const currentSettings = {
                protocol: cli_core_1.Base.state.protocol,
                baseUrl: cli_core_1.Base.state.baseUrl,
                apiKey: cli_core_1.Base.state.apiKey,
                model: cli_core_1.Base.state.model,
                agentServerUrl: cli_core_1.Base.state.agentServerUrl,
                options: cli_core_1.Base.state.options,
            };
            cli_core_1.Base.state.success = await (0, chat_utils_1.runChatLoop)(currentSettings, cli_core_1.Base.state.taskMode);
        }
        catch (error) {
            cli_core_1.CLI.loading.fail(`AI 运行环境初始化出错: ${error.message}`);
            cli_core_1.Base.state.success = false;
        }
        cli_core_1.Wait.next();
    },
    async writing() {
        cli_core_1.Wait.next();
    },
    async install() {
        cli_core_1.Wait.next();
    },
    end() {
        if (cli_core_1.Base.state.success) {
            cli_core_1.CLI.loading.succeed(`🎉 命令行端本地AI编程助手对话结束！`);
        }
        else {
            cli_core_1.CLI.loading.warn('\n任务执行完成，但可能存在异常，请检查上方日志');
        }
        cli_core_1.Wait.next();
    },
});
